// extracted by mini-css-extract-plugin
export default {"root":"ADx4y3","link":"DsvSEM","counter":"yeK0lS"};